<template>
    <div>
        <rkm-table
            :fields="fields"
            :items="data.estoque.model.centrosCusto"
        >
            <template v-slot:cell(actions)="{ index, item }">
                <rkm-button
                    @click="configurarGrupos(item)"
                    color="primary"
                    small
                    title="Configurar estoque"
                >
                    <rkm-icon icon="cog" />
                </rkm-button>

                <rkm-button
                    :disabled="item.isSaved"
                    @click.stop="remove(index)"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>

        <ModalGrupo ref="ModalGrupo" />
    </div>
</template>

<script>
// Components.
import ModalGrupo from './components/grupo/Modal'

import { mapActions } from 'vuex'
import { repository, error } from '@/mixins'

export default {
    components: { ModalGrupo },
    computed: {
        fields() {

            return [
                {
                    key: 'unidadeNomeFantasia',
                    label: 'Unidade',
                    searchable: true,
                    sortable: true
                },
                {
                    key: 'localAtendimentoNome',
                    label: 'Local de atendimento',
                    searchable: true,
                    sortable: true
                },
                {
                    key: 'setorNome',
                    label: 'Setor',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'actions',
                    label: 'Ações',
                    class: 'col-min'
                },
            ]
        },
    },
    created() {

        this.repositories = {
            parametrizacao: this.getConectaSusRepository('almoxarifado.parametrizacao')
        }
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        configurarGrupos(centroCusto) {

            if (centroCusto.grupos.length > 0) {

                this.$refs.ModalGrupo.open(centroCusto)

                return;
            }

            this.setLoading()

            this.repositories.parametrizacao.list({
                origem: 'estoque-minimo-maximo',
                listar: 'grupos',
                centro_custo_id: centroCusto.id
            })
                .then(({ data }) => {

                    centroCusto.grupos = data

                    this.$refs.ModalGrupo.open(centroCusto)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        remove(index) {

            this.showDeleteConfirmation(
                'Deseja realmente excluir o centro de custo?',
                async () => this.data.estoque.model.centrosCusto.splice(index, 1)
            )
        },
    },
    mixins: [repository, error],
    props: {
        data: { type: Object, required: true }
    },
}
</script>